import { useState } from "react";
import { Field, Honeypot, SubmitButton, SuccessBlock, useSubmit, inputCls, selectCls, validPhone, validEmail } from "./fields";
import { toast } from "sonner";

const INIT = { college_name: "", tpo_name: "", designation: "", phone: "", email: "", course: "", num_students: "", requirement_type: "", preferred_program: "", preferred_date: "", message: "", website: "" };

export default function CollegeForm() {
  const [f, setF] = useState(INIT);
  const { submit, loading, success, setSuccess } = useSubmit("/college-enquiries", "Partnership enquiry received. Our team will contact you shortly.");
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!validPhone(f.phone)) return toast.error("Please enter a valid phone number.");
    if (!validEmail(f.email)) return toast.error("Please enter a valid email address.");
    const ok = await submit(f);
    if (ok) setF(INIT);
  };

  if (success)
    return <SuccessBlock testId="college-form-success" message="Thank you. Your partnership enquiry has been received. Our team will contact you shortly." contactEmail="career@maqlinesolutions.com" onReset={() => setSuccess(false)} />;

  return (
    <form onSubmit={onSubmit} className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-testid="college-form">
      <Honeypot value={f.website} onChange={set("website")} />
      <Field label="College Name" required><input data-testid="cf-college" className={inputCls + " w-full"} value={f.college_name} onChange={set("college_name")} required /></Field>
      <Field label="TPO / Faculty Name" required><input data-testid="cf-tpo" className={inputCls + " w-full"} value={f.tpo_name} onChange={set("tpo_name")} required /></Field>
      <Field label="Designation"><input className={inputCls + " w-full"} value={f.designation} onChange={set("designation")} placeholder="e.g. Placement Officer" /></Field>
      <Field label="Phone" required><input data-testid="cf-phone" className={inputCls + " w-full"} value={f.phone} onChange={set("phone")} required placeholder="+91" /></Field>
      <Field label="Email" required><input data-testid="cf-email" type="email" className={inputCls + " w-full"} value={f.email} onChange={set("email")} required /></Field>
      <Field label="Course"><input className={inputCls + " w-full"} value={f.course} onChange={set("course")} placeholder="e.g. Diploma — Mechanical" /></Field>
      <Field label="Number of Students"><input className={inputCls + " w-full"} value={f.num_students} onChange={set("num_students")} placeholder="e.g. 60" /></Field>
      <Field label="Requirement Type">
        <select className={selectCls} value={f.requirement_type} onChange={set("requirement_type")}>
          <option value="">Select</option>
          {["Internships", "Industrial Training", "Placement Support", "Recruitment Drive", "Industry Exposure", "Multiple / Other"].map((r) => <option key={r}>{r}</option>)}
        </select>
      </Field>
      <Field label="Preferred Program">
        <select className={selectCls} value={f.preferred_program} onChange={set("preferred_program")}>
          <option value="">Select</option>
          {["Industrial Internship", "Industrial Training", "Online Internship", "Technical Exposure", "Manufacturing Exposure"].map((p) => <option key={p}>{p}</option>)}
        </select>
      </Field>
      <Field label="Preferred Date"><input type="date" className={inputCls + " w-full"} value={f.preferred_date} onChange={set("preferred_date")} /></Field>
      <Field label="Message" className="sm:col-span-2"><textarea className={inputCls + " w-full h-24 py-2.5"} value={f.message} onChange={set("message")} placeholder="Tell us about your students and what you're looking for" /></Field>
      <div className="sm:col-span-2">
        <SubmitButton loading={loading} testId="college-form-submit">Partner With Maqline</SubmitButton>
      </div>
    </form>
  );
}
